// locationContext.js

import { createContext, useState } from "react";

// Create Context
export const LocationContext = createContext();

// Provider Component
export const LocationProvider = ({ children }) => {
  // Locations State
  const [locations, setLocations] = useState({
    Loc1: {
      name: "Gee Kay Grand Hotel and Banquet",
      address: "Near Naveen Galla Mandi, Lucknow - Shahjahanpur Road, Sitapur Rd, Ismailpur, Uttar Pradesh 261001",
      data: "21, 22, 23 July",
      img: "https://dynamic-media-cdn.tripadvisor.com/media/photo-o/0a/c5/d1/bc/full-view-banquet-hall.jpg?w=1800&h=1000&s=1",
    },

    Loc2: {
      name: "Hotel Mahendra Plaza",
      address: "Circular Rd, near Avas Vikas, Nagheta Purvi, Avas Vikas Colony, Hardoi, Uttar Pradesh 241001",
      data: "25, 26, 27 July",
      img: "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWl5_zI1HAw5AcurYTu8vWeVXND9HKCPr0hrsHVK7iVPHx6VhU6vYT-lRi6hKeapfqfS-O-rIG1N14XMjL3-aTy7XUqjX0mcwQhIdFG_i7rkCLdup7VFPOcQmiWtuUZUuq1RNgTL=s1360-w1360-h1020-rw",
    },
    Loc3: {
      name: "Radisson Blu Hotel",
      address: "TAJ GANGES, VARANASI",
      data: "29, 30, 31 May",
      img: "https://dynamic-media-cdn.tripadvisor.com/media/photo-o/2c/20/d0/37/taj-ganges.jpg?w=900&h=-1&s=1",
    },
  });

  // Update Specific Location
  const updateLocation = (locationId, newData) => {
    setLocations((prevLocations) => ({
      ...prevLocations,

      [locationId]: {
        ...prevLocations[locationId],
        ...newData,
      },
    }));
  };

  return (
    <LocationContext.Provider
      value={{
        locations,
        updateLocation,
      }}
    >
      {children}
    </LocationContext.Provider>
  );
};
